import { useState, useEffect, useRef, RefObject } from 'react'

export function useElementSize<T extends Element>(): [RefObject<T | null>, { width: number, height: number }] {
  const ref = useRef<T>(null)
  const [size, setSize] = useState({ width: 0, height: 0 })

  useEffect(() => {
    const element = ref.current

    if (!element) return

    const updateSize = (entries: ResizeObserverEntry[]) => {
      const entry = entries[0]
      if (entry) {
        const { width, height } = entry.contentRect
        setSize({ width, height })
      }
    }

    const resizeObserver = new ResizeObserver(updateSize)
    resizeObserver.observe(element)

    return () => {
      resizeObserver.disconnect()
    }
  }, [])

  return [ref, size]
}
